import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"

import SocialIcon from "@kit/design/social-icon"
import Modal, { Action } from "@kit/design/modal"
import { toast } from "@kit/design/toast"

import { Input } from "core/deprecated-inputs"
import { useFetch } from "hooks/use-new-fetch"
import { isValidEmbedUrl } from "core/editor"

export const VideoEmbed = props => {
  const { active, onSave, onClose, ...attributes } = props
  const [href, setHref] = useState("")
  const [embedRequest, loading] = useFetch("/api/v3/embed")

  const handleHrefChange = event => {
    const { value } = event.target
    setHref(value)
  }

  const handleSubmit = async event => {
    event.preventDefault()

    if (!isValidEmbedUrl(href)) {
      toast({ type: "error", text: "This is not a YouTube or Vimeo URL." })
      return false
    }

    try {
      const { data: responseData } = await embedRequest.get({
        queryParams: { url: href, maxwidth: "480" }
      })

      setHref("")

      onSave(href, responseData.html)
    } catch (_) {
      toast({
        type: "error",
        text: "There was a problem embedding the video. Try again later or contact us!"
      })
    }
  }

  const callbackRef = useCallback(inputElement => {
    if (inputElement) {
      inputElement.focus()
    }
  }, [])

  return (
    active && (
      <Modal {...attributes} label={"Embed video"} onClose={onClose}>
        <div className="mb-4">
          <SocialIcon
            name="youtube"
            className="mr-2"
            style={{ color: "#f00", fontSize: "48px" }}
          />
          <SocialIcon
            name="vimeo"
            style={{ color: "#1ab7ea", fontSize: "48px" }}
          />
        </div>
        <div className="mb-4">
          <p>Type or paste a YouTube or Vimeo link</p>
        </div>

        <form onSubmit={handleSubmit} className="inline-flex">
          <Input
            aria-label="Video link"
            name="href"
            placeholder="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            ref={callbackRef}
            onChange={handleHrefChange}
            value={href}
            className="inline-flex items-center border border-gray-200 px-3 h-10 rounded-l-sm focus:outline-none focus:border-gray-500 hover:border-gray-500"
            style={{ width: "450px" }}
          />
        </form>
        <Action is="secondary" onClick={onClose}>
          Close
        </Action>
        <Action is="primary" disabled={loading} onClick={handleSubmit}>
          {loading ? "Loading" : "Embed"}
        </Action>
      </Modal>
    )
  )
}

VideoEmbed.propTypes = {
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  active: PropTypes.bool
}
